import { Row, Col  } from "reactstrap";
import DialogBox from "../../../components/DialogBox";
import { useTheme } from "../../../hooks/useTheme";

const QuoteLiveFilesDialog = ({ isDialogBoxOpened, liveFiles = [], closeDialogBox, skipButtonAction, updateLiveButtonAction }) => {
    const theme = useTheme();
    return (
        <DialogBox
            isOpen={isDialogBoxOpened}
            title="Update Live Folder?"
            size="xl"
            message={


                <div className="small mx-3">
                    <Row>
                        <Col>
                            {/* <i className="bi bi-exclamation-triangle-fill me-2"></i>                                 */}
                            <p>Updating the [LIVE] folder will remove or replace the following existing files for this Quote:</p>

                            {/* <p className="mt-3"><strong>Files to be removed or replaced:</strong></p> */}
                            <div style={{ height: '320px', overflowY: 'auto', width: '100%' }}>
                                <table className="table table-sm table-bordered mb-2" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Filename</th>
                                            <th className="text-end">Target folder</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {liveFiles.filter(file => (file.action).toLowerCase() === 'delete').length > 0 ? (
                                            liveFiles
                                                .filter(file => (file.action).toLowerCase() === 'delete')
                                                .map((file, index) => (
                                                    <tr key={`${file.name || 'file'}-${index}`}>
                                                        <td>{file.name || '-'}</td>
                                                        <td className="text-end">{file.parentFolder || '-'}</td>
                                                    </tr>
                                                ))
                                        ) : (
                                            <tr>
                                                <td colSpan="2">No live files found to remove/replace.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col>

                            <hr />
                            <p><strong>Files to be added or updated:</strong></p>
                            <div style={{ height: '200px', overflowY: 'auto', width: '100%' }}>
                                <table className="table table-sm table-bordered mb-2" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Filename</th>
                                            <th className="text-end">Source folder</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {liveFiles.filter(file => (file.action).toLowerCase() === 'insert').length > 0 ? (
                                            liveFiles
                                                .filter(file => (file.action).toLowerCase() === 'insert')
                                                .map((file, index) => (
                                                    <tr key={`${file.name || 'file'}-${index}`}>
                                                        <td>{file.name || '-'}</td>
                                                        <td className="text-end">{file.parentFolder || '-'}</td>
                                                    </tr>
                                                ))
                                        ) : (
                                            <tr>
                                                <td colSpan="2">No draft files found.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row > */}

                    <div className="mt-2">
                        {/* <p>Quote documents belonging to other Quotes will not be affected.</p> */}
                        <p>Do you want to continue?</p> 
                    </div>
                </div>
            }
            toggle={closeDialogBox}
            buttons={
                [
                    {
                        label: 'Skip',
                        color: theme === "dark-mode" ? "dark" : "light",
                        outline: true,
                        // icon: 'bi bi-x-circle',
                        onClick: () => { skipButtonAction(); closeDialogBox(); }
                    },
                    {
                        label: 'Update Live Folder',
                        color: 'secondary',
                        // icon: 'bi bi-check2-circle',
                        onClick: () => { updateLiveButtonAction(); closeDialogBox(); }
                    }
                ]}
        />
    );
}

export default QuoteLiveFilesDialog;